import script from "./PeopleGroupsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleGroupsPanel.vue?vue&type=script&setup=true&lang=js"

import "./PeopleGroupsPanel.vue?vue&type=style&index=0&id=415e1e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415e1e3e"]])

export default __exports__